export default "__VITE_ASSET__BB0RZUAT__"